<template>
  <section
    style="display: flex; flex-direction: column; justify-content: space-between;"
    class="content"
  >
    <vue-image-crop-upload
      v-model="showImageCrop"
      langType="pt-br"
      @crop-success="cropImage"
      :noCircle="true"
      :width="440"
      :height="300"
    ></vue-image-crop-upload>
    <div
      style="font-weight: 600; display: flex; justify-content: space-between; align-items: center;"
    >
      <div style="display: flex; font-weight: 600; ">
        CATEGORIAS
        <div class="dot"></div>
        <div>{{ categories.length }}</div>
      </div>
      <div
        style="display: flex; justify-content: space-between; align-items: center; width: 280px;"
      >
        <div style="max-width: 200px;">
          <a class="btn btn--border-only">
            <div style="display: flex; align-items: center; width: 100%;">
              <div style="margin-right: 5px;">
                <icon name="search" />
              </div>
              <input
                type="text"
                class="input input-search"
                style="border:0; margin-bottom: 5px; text-transform: none;"
                placeholder
                @input="onSearchChange($event.target.value || '', getCategories)"
                :value="this.filters.search"
              />
            </div>
          </a>
        </div>
        <div class="box-add-icon" @click="openModalAdd()">
          <fa size="lg" icon="plus" />
        </div>
      </div>
    </div>
    <table class="principal-table">
      <thead>
        <th
          style="text-align: left; cursor: pointer;"
          @click="setOrderByName(getCategories)"
        >Nome {{ getSelectedOrder }}</th>
      </thead>
      <tbody>
        <tr
          v-for="category of categories"
          :key="category.id"
          class="item"
          :class="{ 'disabled-row': category.status === 'inactive' }"
        >
          <td style="text-align: left;">{{ category.name }}</td>
          <td style="width: 60px;" class="edit-icon" @click="editCategory(category)">
            <fa size="lg" icon="edit"></fa>
          </td>
        </tr>
      </tbody>
    </table>
    <div>
      <app-modal v-if="showModal" @close="closeModalEdit()" @action="validateCategoryInput()">
        <template slot="header">
          <div style="margin-right: 20px; color: #C3C5C6;">EDITAR CATEGORIA</div>
        </template>
        <template slot="body">
          <div style="display: flex; justify-content: space-between; width: 480px;">
            <div @click="showImageCrop = true">
              <img
                style="width: 220px; height: 150px; border-radius: 5px;"
                :src="categoryToEdit.imageUrl"
                alt="Imagem do produto"
              />
              <div>
                <button style="width: 100%; font-size: 1em;" class="btn">Editar imagem</button>
              </div>
            </div>
            <div style="display: flex; flex-direction: column; justify-content: space-between;">
              <div class="wrapInputs">
                <div class="editInputs">
                  <div>
                    Nome
                    <input
                      type="text"
                      class="input input-config"
                      style="text-transform: none;"
                      placeholder="Digite o nome da categoria"
                      :value="categoryToEdit.name"
                      @input="categoryToEdit.name = $event.target.value"
                    />
                  </div>
                  <div>
                    Relevância
                    <input
                      type="number"
                      class="input input-config"
                      :value="categoryToEdit.weight == null ? 0 : categoryToEdit.weight"
                      @input="categoryToEdit.weight = $event.target.value"
                    />
                  </div>
                </div>
                <div>
                  <div style="margin-top: 20px;">
                    <app-switch
                      class="switch-toggle"
                      v-model="categoryToEdit.isActive"
                      :label="`Categoria ativo no Zepplin`"
                    />
                  </div>
                  <div style="margin-top: 20px;">
                    <app-switch
                      class="switch-toggle"
                      v-model="categoryToEdit.isFeatured"
                      :label="`Em destaque no Zepplin`"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </template>
      </app-modal>

      <app-modal
        v-if="showModalAdd"
        @close="closeModalAdd()"
        btnActionName="Adicionar"
        @action="validateCategoryInput()"
      >
        <template slot="header">
          <div style="margin-right: 20px; color: #C3C5C6;">ADICIONAR NOVA CATEGORIA</div>
        </template>
        <template slot="body">
          <div style="display: flex; justify-content: space-between; width: 480px;">
            <div @click="showImageCrop = true" style="cursor: pointer;">
              <div v-if="categoryToEdit.imageUrl">
                <img
                  style="width: 220px; height: 150px; border-radius: 5px;"
                  :src="categoryToEdit.imageUrl"
                  alt="Imagem do produto"
                />
                <div>
                  <button style="width: 100%; font-size: 1em;" class="btn">Editar imagem</button>
                </div>
              </div>
              <div
                v-else
                style="width: 220px; height: 150px; border-radius: 5px; background: #666; display: flex; align-items: center; justify-content: center; color: white;"
              >Adicionar imagem</div>
            </div>
            <div style="display: flex; flex-direction: column; justify-content: space-between;">
              <div class="wrapInputs">
                <div class="editInputs">
                  <div>
                    Nome
                    <input
                      type="text"
                      class="input input-config"
                      style="text-transform: none;"
                      placeholder="Digite o nome da categoria"
                      :value="categoryToEdit.name"
                      @input="categoryToEdit.name = $event.target.value"
                    />
                  </div>
                  <div>
                    Relevância
                    <input
                      type="number"
                      class="input input-config"
                      :value="categoryToEdit.weight == null ? 0 : categoryToEdit.weight"
                      @input="categoryToEdit.weight = $event.target.value"
                    />
                  </div>
                </div>
                <div>
                  <div style="margin-top: 20px;">
                    <app-switch
                      class="switch-toggle"
                      v-model="categoryToEdit.isActive"
                      :label="`Categoria ativo no Zepplin`"
                    />
                  </div>
                  <div style="margin-top: 20px;">
                    <app-switch
                      class="switch-toggle"
                      v-model="categoryToEdit.isFeatured"
                      :label="`Em destaque no Zepplin`"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </template>
      </app-modal>
    </div>
  </section>
</template>

<script>
import { mapActions, mapState } from "vuex";
import Treeselect from "@riophae/vue-treeselect";
import ZepplinProductsAPI from "../../../api/zepplin/products";
import FiltersHelper from "./FiltersHelper";
import * as yup from "yup";

export default {
  props: ["user"],
  mixins: [FiltersHelper],
  data() {
    return {
      categoryToEdit: {},
      showModal: false,
      showModalRemove: false,
      showModalAdd: false,

      categories: [],

      showImageCrop: false
    };
  },
  components: { Treeselect },
  computed: {
    ...mapState("auth", ["company", "zepplinMasterToken"])
  },
  methods: {
    ...mapActions("toast", ["showToast", "showError"]),

    closeModalAdd() {
      this.showModalAdd = false;
    },

    closeModalEdit() {
      this.showModal = false;
    },

    editCategory(category) {
      _.assign(this.categoryToEdit, {
        ...this.utils.removeReactivity(category),
        isActive: category.status === "active" ? true : false
      });
      this.showModal = true;
    },

    cropImage(data, url) {
      this.categoryToEdit.imageUrl = data;
    },

    async submit() {
      this.$emit("saving", true);

      try {
        const categoryForm = this.handleCategoryForm(this.categoryToEdit);
        if (this.categoryToEdit.id)
          await ZepplinProductsAPI.updateCategory(
            this.categoryToEdit.id,
            categoryForm,
            { masterToken: this.zepplinMasterToken }
          );
        else
          await ZepplinProductsAPI.createCategory(categoryForm, {
            masterToken: this.zepplinMasterToken
          });

        await this.getCategories();
        this.showToast({
          type: "success",
          message: "Operação realizada com sucesso!"
        });
      } catch (err) {
        console.error(err);
        this.showError("Não foi possível completar a operação.");
        return;
      } finally {
        this.$emit("saving", false);
      }

      this.showModal = false;
      this.showModalAdd = false;
      this.productImage = "";
    },

    handleCategoryForm({ name, imageUrl, weight, isFeatured, isActive }) {
      return {
        name,
        imageUrl,
        weight,
        isFeatured: Boolean(isFeatured),
        status: isActive ? "active" : "inactive"
      };
    },

    async validateCategoryInput() {
      if (!this.categoryToEdit.weight || this.categoryToEdit.weight === "") {
        this.categoryToEdit.weight = 0;
      }
      await schema
        .validate({
          name: this.categoryToEdit.name,
          image: this.categoryToEdit.imageUrl,
          weight: this.categoryToEdit.weight
        })
        .then(() => {
          this.submit()
          })
        .catch(error => this.showError(error.message));
    },

    openModalAdd() {
      this.categoryToEdit = {
        name: null,
        imageUrl: null,
        categoryId: null,
        isActive: true
      };
      this.showModalAdd = true;
    },

    async getCategories() {
      this.categories = await ZepplinProductsAPI.getList({
        hasInclude: false,
        ...this.filters
      }).then(res => res.data);
      window.removeAppLoading(); 
    }
  },
  async mounted() {
    window.showAppLoading();
    window.setAppLoadingText("Carregando lista...");
    await this.getCategories();
  }
};

const schema = yup.object().shape({
  name: yup.string().required("Adicione um nome ao produto").nullable(),
  image: yup.string().required("A imagem é necessária.").nullable(),
  weight: yup
    .number()
    .required("Campo relevância requerido")
});
</script>

<style lang="scss" scoped>
.line {
  width: 100%;
  height: 1px;
  border-bottom: solid 1px #52566281;
}
.input-config {
  border-bottom: 1px solid #525662;
  width: 100%;
}

.column {
  width: 45%;
  font-weight: 600;
}

.content-column {
  margin-top: 20px;
}

.content {
  margin-bottom: 50px;
}

.item {
  height: 40px;
  text-align: center;
}

.footer-config {
  position: fixed;
  bottom: 0;
  padding-top: 2vh;
  padding-bottom: 10vh;
  padding-right: 10vh;
  right: 0;
  background: #23272b;
  width: 100%;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.301);
}

.active-btn {
  background: #0072e4;
}

.edit-icon:hover {
  color: #0072e4;
  cursor: pointer;
}

.delete-icon:hover {
  color: #c22f2f9d;
  cursor: pointer;
}

.disabled-row {
  opacity: 0.3;
}

.principal-table tbody tr:nth-child(odd) {
  background: rgba(22, 26, 29, 0.404);
}

.principal-table {
  margin-top: 20px;
}

.box-add-icon {
  width: 50px;
  height: 30px;
  border-radius: 50px;
  background: linear-gradient(89.39deg, #0072e4 -0.59%, #25a0a8 100.95%);
  color: white;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}

.box-add-icon:hover {
  background: #0072e4;
}

.product-image {
  width: 650px;
  height: 300px;
}

.number-input {
  background: transparent;
  color: white;
  font-size: 0.9em;
  border: none;
  width: 50px;
}

.wrapInputs {
  padding: 0 20px;
}

.editInputs div {
  margin: 10px 0px;
}
</style>
